import { useQuery } from "react-query";
import Select from "react-select"

import { getCompanies } from "../../../../../MyApi/hr/companies";
import { getBranches } from "../../../../../MyApi/sb/branches";
import { getDepartments } from "../../../../../MyApi/sb/departments";
import { getCurrency } from "../../../../../MyApi/sb/currency";
import { getLevels } from "../../../../../MyApi/hr/levels";
import { getDesignations } from "../../../../../MyApi/hr/designations";
import { getEmployes } from "../../../../../MyApi/sb/employes";

import LoadingSpinner from "../../../../UI/spinner";
import icons from "../../../../../Data/icons";
import SalaryComponentUpdate from "../salaryComponentupdate";

import classes from "./addConstracts.module.css";



const EditConstracts = ({
 signing_date,join_date ,end_date, start_date,description,  
  companyId, branchId, employId, departmentId, currencyId,desgnationId,
  setDepartmentId,
  setEmployId,
  total,
  rows,
  handleAddRow,
  salaryComponentObject,
  setTotal,
  setBranchId,
  intership,
  setRows,
  levelId,
  setCurrencyId,
  handleRemoveRow,
  setSalaryComponentObject,
  setPaidPeriod,
  setStatus,
  setJoin_date,
  setInterShipEndDate,
  setInterShip,
  setHr_designation_id,
  setLevelId,
  setStart_date,
  setCompanyId,
  setDescription,
  setActive,
  active,
  setDuration,
  setDurationType,
  setEnd_date,
  setSigningDate,
  duration_type,
  duration,status,
  paidPeriod,
  

}) => {
  const page=0
  const compainesQuery = useQuery("getComapines", getCompanies);
  const branchesQuery = useQuery(["branchesQuery",page,companyId], ()=>getBranches(page,companyId));
  const departmentsQuery = useQuery(["getDepartments" ,page,branchId] , ()=>getDepartments(page,branchId));
  const currencyQuery = useQuery("getcurriencs", getCurrency);
  const levelQuery = useQuery("getlevels", getLevels);
  const designationQuery = useQuery("getDesignation", getDesignations);
 const employQuery = useQuery(["getEmployes" ,page,branchId] ,()=>getEmployes(page,branchId) )

  const compaines = compainesQuery.data?.data || [];
  const branches = branchesQuery.data?.data || [];
  const departments = departmentsQuery.data?.data || [];
  const currencies = currencyQuery.data?.data || [];
  const levels = levelQuery.data?.data || [];
  const designations = designationQuery.data?.data || [];
  const employes =  employQuery.data?.data || []

  const DescriptionIcon = icons.description;
  const LevelIcon = icons.levels;
  const DollarSign = icons.Dollar;
  const Company = icons.company;
  const DateIcon = icons.date
  const TimeIcon = icons.timeline

  const defaultDepartment =departments.find((option=> option.id ===departmentId))
  const defaultDesignations =designations.find((option=> option.id ===desgnationId))
  const defaultEmploy =employes.find((option=> option.id ===employId))
  const defaultCurrency =currencies.find((option=> option.id ===currencyId))
  const defaultCompany =compaines.find((option=> option.id ===companyId))
  const defultBranch = branches.find((option => option.id ===branchId))
  const defultLevels =levels.find((option => option.id ===levelId))


  const handleEmployId =(selectedOption)=>{
    const employId = selectedOption ? selectedOption.id :0
    setEmployId(employId)
  }
  const handleBrachIdChange = (selectedOption) => {
    const branchId = selectedOption ?selectedOption.id:0
    setBranchId(branchId);
  };
  const handleDepartmentIdChange = (selectedOption) => {
    const departmentsId = selectedOption ?selectedOption.id :0
    setDepartmentId(departmentsId);
  };
  const handleCurrencyIdChange = (selectedOption) => {
    const currencyId = selectedOption? selectedOption.id :0
    setCurrencyId(currencyId)
  };
  const handleLevelIdChange = (selectedOption) => {
    const levelId =selectedOption? selectedOption.id :0
    setLevelId(levelId);
  };
  const handleCompanyIdChange = (selectedOption) => {
    const companyId = selectedOption ? selectedOption.id :0
    setCompanyId(companyId);
 
  };
  const handleDesignationChange = (selectedOption) => {
    const desgnationId = selectedOption ?selectedOption.id :0
    setHr_designation_id(desgnationId);

  };

  const handleDescChange = (e) => {
    setDescription(e.target.value);
  };
  const handleStartDateChange = (e) => {
    setStart_date(e.target.value);
  };
  const handleEndDateChange = (e) => {
    setEnd_date(e.target.value);
  };
  const handleJoinDate = (e) => {
    setJoin_date(e.target.value);
  };

  const handleInternshipChange = (e) => {
    const isChecked = e.target.checked;
    setInterShip(isChecked ? 1 : 0);
  };
  const handleInternshipEndDateChange = (e) => {
    setInterShipEndDate(e.target.value);
  };
  const handlePeriodPaidChange = (e) => {
    setPaidPeriod(e.target.value);
  };

  const handleStatus = (e) => {
    setStatus(e.target.value);
  };

  const handleSigninDate = (e) => {
    setSigningDate(e.target.value);
  };
  const handleActiveChange = (e) => {
    const isChecked = e.target.checked;
    setActive(isChecked ? 1 : 0);
  };
  const handleTotal =(e)=>{
    setTotal(+e.target.value)
  }
  const handleDuration=(e)=>{
   setDuration(+e.target.value)
  }
  const handleDurationType =(e)=>{
   
    setDurationType(e.target.value)
  }

  if (
    compainesQuery.isLoading ||
    branchesQuery.isLoading ||
    departmentsQuery.isLoading ||
    currencyQuery.isLoading ||
    levelQuery.isLoading ||
    designationQuery.isLoading
  ) {
    return <LoadingSpinner />;
  }

  const paidPeriodData = ["weekly", "monthly", "quarter", "yearly"];
  const statuses = ["active", "pending", "canceled", "expired"];

  return (
    <div className="row">
      <div className="col-lg-6">
    <div className={classes.formCard}>
      <div className={classes.formGrid}>
          <div className={classes.formCol}>
          <label htmlFor=""> الشركة</label>
          {!compainesQuery.data ? (
            <div>no data available </div>
          ) : (        
            <Select
              options={compaines}
              value={defaultCompany}
              getOptionValue={(e)=>e.id}
              getOptionLabel={(e)=>e.name}
              placeholder="اختار الشركة  "
              onChange={handleCompanyIdChange}
            />
          )}
        </div>

       

        <div className={classes.formCol}>
          <label htmlFor=""> الفرع</label>
          {!branchesQuery.data ? (
            <div>no data available </div>
          ) : (
            <Select
              type="text"
              value={defultBranch}
              placeholder="اختار الفرع"
              options={branches}
              getOptionValue={(e)=>e.id}
              getOptionLabel={(e)=>e.name}
              onChange={handleBrachIdChange}
            />
          )}
        </div>

        <div className={classes.formCol}>
          <label htmlFor=""> القسم</label>
          {!departmentsQuery.data ? (
            <div>no data available </div>
          ) : (
            <Select
              type="text"
              placeholder="اختار القسم"
              value={defaultDepartment}
              options={departments}
              getOptionValue={(e)=>e.id}
              getOptionLabel={(e)=>e.name}
              defaultValue={defaultDepartment}
              onChange={handleDepartmentIdChange}/>            
          )}
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> الموظفين</label> 
          {!employQuery.data ? (
            <div>no data available </div>
          ) : (
            <Select
              type="text"
              value={defaultEmploy}
              placeholder="اختار الموظف  "
              options={employes}
              getOptionValue={(e)=>e.id}
              getOptionLabel={(e)=>e.name_ar}
              onChange={handleEmployId}/>
          )}
        </div>


        <div className={classes.formCol}>
          <label htmlFor=""> العملة</label>
          {!currencyQuery.data ? (
            <div>no data available </div>
          ) : (
            <Select
              type="text"
              placeholder="اختار العملة"
              value={defaultCurrency}
              getOptionValue={(e)=>e.id}
              getOptionLabel={(e)=>e.name}
              options={currencies}
              onChange={handleCurrencyIdChange}/>
          )}
        </div>

        <div className={classes.formCol}>
          <label htmlFor=""> المستوي</label>
          {!levelQuery.data ? (
            <div>no data available </div>
          ) : (
            <Select
              type="text"
              placeholder="اختار المستوي  "
              value={defultLevels}
              onChange={handleLevelIdChange}
              getOptionLabel={(e)=>e.name}
              getOptionValue={(e)=>e.id}
              options={levels}
            />
          
          )}
        </div>

        <div className={classes.formCol}>
          <label htmlFor=""> اختار المسميات</label>
          {!designationQuery.data ? (
            <div>no data available </div>
          ) : (
            <Select
              type="text"
              placeholder="اختار المسميات  "
              value={defaultDesignations}
              options={designations}
              getOptionValue={(e)=>e.id}
              getOptionLabel={(e)=>e.name}
              onChange={handleDesignationChange}/>

          )}
        </div>

   

        <div className={classes.formCol}>
          <label htmlFor=""> اختار فترة دفع الأجر </label>
          <div className={classes.iconInput}>
            <DollarSign />
          </div>

          <select
            type="text"
            placeholder="اختار فترة دفع الأجر    "
            value={paidPeriod}
            onChange={handlePeriodPaidChange}
            className={classes.inputCustom}>
            <option selected>اختار فترة دفع الأجر </option>
            {paidPeriodData.map((paidPeriod, i) => (
              <option key={i} >
                {paidPeriod}
              </option>
            ))}
          </select>
        </div> 

        <div className={classes.formCol}>
          <label htmlFor=""> اختار الحالة </label>
          <div className={classes.iconInput}>
            <Company />
          </div>

          <select
            type="text"
            value={status}
            placeholder="اختار   الحالة    "
            onChange={handleStatus}
            className={classes.inputCustom}>
            <option selected>اختار الحالة </option>
            {statuses.map((status, i) => (
              <option key={i} value={status}>
                {status}
              </option>
            ))}
          </select>
        </div>

      </div>
    </div>
      </div>
      <div className="col-lg-6">
      <div className={classes.formCard}>
        <div className={classes.formGrid}>

        <div className={classes.formCol}>
          <label htmlFor="">الوصف </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <textarea
            type="textarea"
            placeholder="ادخل  الوصف"
            onChange={handleDescChange}
            value={description}
            className={classes.inputCustom}>
            {" "}
          </textarea>
        </div>

        <div className={classes.formCol}>
          <label htmlFor="">تاريخ البداية </label>
          <div className={classes.iconInput}>
            <DateIcon />
          </div>
          <input
            type="date"
            value={start_date}
            placeholder="ادخل تاريخ البداية"
            onChange={handleStartDateChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">تاريخ الانتهاء </label>
          <div className={classes.iconInput}>
            <DateIcon />
          </div>
          <input
            type="date"
            value={end_date}
            placeholder="ادخل تاريخ الانتهاء"
            onChange={handleEndDateChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">تاريخ الانضمام </label>
          <div className={classes.iconInput}>
            <DateIcon />
          </div>
          <input
            type="date"
            value={join_date}
            placeholder="ادخل تاريخ الانضمام"
            onChange={handleJoinDate}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">تاريخ التوقيع </label>
          <div className={classes.iconInput}>
            <DateIcon />
          </div>
          <input
            type="date"
            value={signing_date}
            placeholder="ادخل تاريخ التوقيع"
            onChange={handleSigninDate}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> المجموع </label>
          <div className={classes.iconInput}>
            <DateIcon />
          </div>
          <input
            type="number"
            value={total}
            placeholder="ادخل  المجموع"
            onChange={handleTotal}
            className={classes.inputCustom}
          />
        </div>

        
        
        <div className={classes.formCol}>
          <label htmlFor="">  المدة </label>
          <div className={classes.iconInput}>
            <TimeIcon />
          </div>
          <input
          value={duration}
            type="number"
            placeholder="ادخل المدة"
            onChange={handleDuration}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> اختار نوع المدة</label>
          <div className={classes.iconInput}>
            <TimeIcon />
          </div>

          <select
            type="text"
            value={duration_type}
            placeholder="اختار نوع المدة  "
            onChange={handleDurationType}
            className={classes.inputCustom}>
            <option selected>اختار نوع المده </option>
            <option id="1" value="monthly">monthly</option>
            <option id="2" value="yearly">yearly</option>
          </select>
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> الراتب </label>

          {rows.map((row, i) => (
            <SalaryComponentUpdate
              key={i}
              row={row}
              rows={rows}
              setRows={setRows}
              setSalaryComponentObject={setSalaryComponentObject}
              handleAddRow={handleAddRow}
              classes={classes}
              salaryComponentObject={salaryComponentObject}
              handleRemoveRow={handleRemoveRow}
            />
          ))}
          <button onClick={handleAddRow} className={classes.addBtn}>
            اضافة راتب
          </button>
        </div>

        <div className={classes.formCol}>
          <label
            htmlFor=""
            className={active ? `${classes.active}` : `${classes.disActive}`}>
            {active === 1 ? " نشط" : "غير نشط"}
          </label>

          <label class="switch">
            <input
              type="checkbox"
              onChange={handleActiveChange}
              checked={active}
            />
            <span class="slider round"></span>
          </label>
        </div>
        
        <div className={classes.formCol}>
          <label
            htmlFor=""
            className={intership ? `${classes.active}` : `${classes.disActive}`}>
            {intership == 1 ? "تدريب" : " لا يوجد تدريب"}
          </label>

          <label class="switch">
            <input
              type="checkbox"
              onChange={handleInternshipChange}
              checked={intership}
            />
            <span class="slider round"></span>
          </label>
        </div>
        {intership ===1&&
        
        
        <div className={classes.formCol}>
          <label htmlFor="">تاريخ انتهاء التدريب </label>
          <div className={classes.iconInput}>
            <DateIcon />
          </div>
          <input
            type="date"
            value={end_date}
            placeholder="ادخل تاريخ انتهاء التدريب"
            onChange={handleInternshipEndDateChange}
            className={classes.inputCustom}
          />
        </div>
        
       }
        </div>

      </div>
      </div>

    </div>

  );
};

export default EditConstracts;
